import { JourneyNodeTypesMap } from '@usealloy/typegen';

import { ACTION_NODE_TYPES } from './constants';

// FIXME: Check if we have a Workflow type so we can have the return value of
// this be "workflowType is Workflow" and it can act as a type check guard
export function isLikeWorkflow(nodeType: string): boolean {
  return [
    JourneyNodeTypesMap.DOCV,
    JourneyNodeTypesMap.RECONCILIATION_WORKFLOW,
    JourneyNodeTypesMap.STEP_UP,
    JourneyNodeTypesMap.WORKFLOW,
  ].includes(nodeType);
}

export function isLikeWorkflowOrSourceWorkflow(nodeType: string): boolean {
  return nodeType === JourneyNodeTypesMap.SOURCE_WORKFLOW || isLikeWorkflow(nodeType);
}

export function isActionNode(actionNodeType: string): boolean {
  return [
    JourneyNodeTypesMap.ACTION,
    ACTION_NODE_TYPES.CUSTOM_REVIEW,
    ACTION_NODE_TYPES.END_USER,
    ACTION_NODE_TYPES.PARENT_REVIEW,
    ACTION_NODE_TYPES.SERVICE,
    ACTION_NODE_TYPES.EVENT_ACTION,
  ].includes(actionNodeType);
}
